import { Input } from 'antd';
import styled from 'styled-components';

const InputRight = styled(Input)`
  input {
    text-align: right;
  }
`;

export default InputRight;
